/** @format */

import { assetsPath } from "../../../../shared/utils/assetsPath";

const PortalCard = ({
  heading = "",
  text = "",
  onClick = () => {},
  button = "",
  className = "",
  image = assetsPath.heart,
}) => {
  return (
    <div className={`portal-card ${className}`} onClick={onClick}>
      <img className="portal-card-img" src={image} alt={`${heading} icon`} />
      <h3 className="portal-card-heading">{heading}</h3>
      <p className="gray-text">{text}</p>
      {button ? (
        <>
          <button onClick={onClick} className="portal-card-button">
            {button}
          </button>
        </>
      ) : null}
    </div>
  );
};

export default PortalCard;
